import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';

import Icon from '~/modules/coreUI/components/basic/Icon';
import { cssMediaMax } from '~/modules/core/utils/cssHelpers/cssMedia';
import externalRedirect from '~/modules/ecommerceCore/utils/externalRedirect';
import { Row } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import { ShopHeaderLabel } from '~/modules/ecommerceShops/components/basic/Labels';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';

export const HeaderIcon = styled(Icon)`
  color: ${props => props.theme.colors.labels.normal};
  font-size: ${props => props.theme.fonts.sizes.large + 3}px;
  ${props => cssMediaMax.tablet`
    margin-right: ${props.theme.paddings.medium}px;
    font-size: ${props.theme.fonts.sizes.large - 1}px;
  `};
`;

const LocationContainer = styled(Row)`
  cursor: pointer;
  ${cssMediaMax.mobile`
    align-items: flex-start;
  `};
`;

const Location = ({ address, lat, lng }) => {
  const openGoogleMap = () => {
    const url = `https://maps.google.com/?q= ${lat},${lng}`;
    externalRedirect(url, '_blank');
  };

  return (
    <LocationContainer fullWidth onClick={openGoogleMap}>
      <HeaderIcon className="icon-location" />
      <Spacer size={1.1} />
      <ShopHeaderLabel>{address}</ShopHeaderLabel>
    </LocationContainer>
  );
};

Location.propTypes = {
  address: PropTypes.string.isRequired,
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
};

export default Location;
